import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const notifications = [{
  flagCode: 'gb',
  countryName: 'United Kingdom',
  location: 'London, UK',
  name: 'Sarah Mitchell',
  initials: 'SM',
  time: '5 minutes ago'
}, {
  flagCode: 'ca',
  countryName: 'Canada',
  location: 'Toronto, Canada',
  name: 'Claire Vance',
  initials: 'CV',
  time: '12 minutes ago'
}, {
  flagCode: 'au',
  countryName: 'Australia',
  location: 'Sydney, Australia',
  name: 'James Reid',
  initials: 'JR',
  time: '18 minutes ago'
}, {
  flagCode: 'us',
  countryName: 'United States',
  location: 'New York, USA',
  name: 'Vera Thompson',
  initials: 'VT',
  time: '27 minutes ago'
}, {
  flagCode: 'ie',
  countryName: 'Ireland',
  location: 'Dublin, Ireland',
  name: 'Sinead Ryan',
  initials: 'SR',
  time: '41 minutes ago'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const timer = window.setTimeout(() => setIsVisible(true), 3000);
    return () => window.clearTimeout(timer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = window.setTimeout(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(previous => (previous + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => window.clearTimeout(hideTimer);
  }, [currentIndex, isDismissed, isVisible]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" data-id="element-237" data-mp="3j94064ht0d14">
      <AnimatePresence mode="wait" data-id="element-238" data-mp="3kruaxcflzyj8">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 40,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-card border border-gold/30 rounded-xl p-3.5 shadow-[0_14px_36px_-12px_rgba(0,0,0,0.8)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-239" data-mp="3ppm0w0wp1aks">
            <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-steel hover:text-white transition-colors duration-150 ease-out" aria-label="Close notification" data-id="element-240" data-mp="36sci8lz7014l">
              <X size={14} data-id="element-241" data-mp="2j2qinxewrjw2" />
            </button>
            <div className="flex items-center gap-3" data-id="element-242" data-mp="2n30ye1si5oo4">
              <div className="relative shrink-0" data-id="element-243" data-mp="2n1r13eth4kij">
                <div className="w-11 h-11 rounded-full bg-card-hi border border-gold/40 flex items-center justify-center text-gold font-display font-bold text-sm" data-id="element-244" data-mp="24egq6adzpvtx">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`${current.countryName} flag`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-card shadow" data-id="element-245" data-mp="2dfomimwy4mld" />
              </div>
              <div className="flex-1 min-w-0 pr-4" data-id="element-246" data-mp="2idgf7j5f0cqm">
                <div className="flex items-center gap-1.5 text-[11px] text-steel mb-0.5" data-id="element-247" data-mp="2icorsvlz1lbf">
                  <img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover" data-id="element-248" data-mp="2w80qtf75txy5" />
                  <span className="truncate" data-id="element-249" data-mp="361rckcbwjua5">{current.location}</span>
                </div>
                <p className="text-white text-[13px] leading-snug" data-id="element-250" data-mp="313679yhsmkeu">
                  <span className="font-bold" data-id="element-251" data-mp="3l6ly4h3ig98t">{current.name}</span>{' '}
                  <span className="text-mist" data-id="element-252" data-mp="3p7xctrkuja28">purchased Boxing Coach Ready</span>
                </p>
                <div className="flex items-center gap-1.5 text-[10px] text-gold font-medium mt-1" data-id="element-253" data-mp="3tz5pcwhh3bjm">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-254" data-mp="2te162n9a8zg" />
                  <ShoppingBag size={10} aria-hidden="true" data-id="element-255" data-mp="3289e20b29eyg" />
                  <span data-id="element-256" data-mp="32a2j5b60zr4c">Verified purchase • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}